import {valueOf} from 'core/Budget';
import {useBudgetStore} from 'store/Budget';

export function useMoneyLeft(): number {
  const budget = useBudgetStore();
  return valueOf(budget);
}
